module.exports = __webpack_public_path__ + "static/media/repeatable-table-on-preview.bc8a874c.png";